module.exports = __webpack_public_path__ + "img/109.74c93cc3.jpg";